import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, first } from 'rxjs/operators';

import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { ShopCartDto } from '../../api';
import { CrisprCartService } from '../crispr-cart.service';
import { AuthService } from '../../shared/auth/auth.service';
import { CrisprService } from '../crispr.service';
import { defs } from '../../defs';
import { Sex } from '../../shared/filter/filter';
import { CatPartBaseDto } from '../../api/catPartBaseDto';

const sortByTranslationKeys = ['sortByOptions.like', 'sortByOptions.productivity', 'sortByOptions.fitness', 'sortByOptions.priceInGtr'];

@Component({
	selector: 'narwhalia-crispr-sidebar',
	templateUrl: './crispr-sidebar.component.html',
	styleUrls: ['./crispr-sidebar.component.scss']
})
export class CrisprSidebarComponent extends OnDestroyMixin implements OnInit {
	crisprFilter: FormGroup;
	sortByParams: any[];
	cartQuantitySum: number;
	showCartPopup: boolean;
	totalCount: number;

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private crisprService: CrisprService,
		private crisprCartService: CrisprCartService,
		private translateService: TranslateService,
		private authService: AuthService
	) {
		super();
		this.translateService.get(sortByTranslationKeys).subscribe(sortByOptions => {
			const [like, productivity, fitness, priceInGtr] = sortByTranslationKeys;
			this.sortByParams = [
				{ viewValue: sortByOptions[like], value: 'like' },
				{ viewValue: sortByOptions[productivity], value: 'productivity' },
				{ viewValue: sortByOptions[fitness], value: 'fitness' },
				{ viewValue: sortByOptions[priceInGtr], value: 'price' }
			];
		});
		this.createForm();
	}

	createForm() {
		this.crisprFilter = this.fb.group({
			sortBy: [defs.sortOrders.defaults.crispr],
			male: [false],
			female: [false]
		});
	}

	patchForm = queryParams => {
		const { sortBy, gender } = queryParams;
		this.crisprFilter.patchValue({
			sortBy,
			male: Sex.isMale(gender),
			female: Sex.isFemale(gender)
		});
	};

	ngOnInit() {
		this.crisprService.queryParams$.pipe(first(queryParams => Object.keys(queryParams).length > 0)).subscribe(queryParams => {
			this.patchForm(queryParams);
			this.crisprFilter.valueChanges.subscribe(this.refreshUrlQueryParams);
			this.handleGenderChange();
		});

		this.authService
			.isLoggedInAsObservable()
			.pipe(
				filter(isLoggedIn => !!isLoggedIn === true),
				untilComponentDestroyed(this)
			)
			.subscribe(() => {
				this.crisprService.getCrisprCart().subscribe((cart: ShopCartDto) => this.crisprCartService.initCart(cart));
				this.crisprCartService.cart$.subscribe(cart => {
					if (this.cartQuantitySum === 0) {
						this.showCartPopup = false;
					}
					this.cartQuantitySum = this.sumCartQuantites(cart);
				});
			});
		this.crisprService.totalCount$.subscribe(totalCount => (this.totalCount = totalCount));
	}

	sumCartQuantites = (cart: Map<CatPartBaseDto, number>) =>
		Array.from(cart.values()).reduce((accumulator, currentValue) => accumulator + currentValue, 0);

	handleGenderChange() {
		this.checkContrary('male', 'female');
		this.checkContrary('female', 'male');
	}

	checkContrary(firstFormControl, secondFormControl) {
		this.crisprFilter
			.get(firstFormControl)
			.valueChanges.subscribe(
				secondGenValue =>
					secondGenValue && this.crisprFilter.get(secondFormControl).value && this.crisprFilter.get(secondFormControl).setValue(false)
			);
	}

	refreshUrlQueryParams = ({ sortBy, male, female }) => {

		const queryParams: Object = {
			gender: Sex.from(male, female),
			sortBy
		};
		this.router.navigate(['crispr'], { queryParams });
	};

	toggleCartPopup(event) {
		event.stopPropagation();
		this.showCartPopup = !this.showCartPopup;
	}
}